import React from "react";
import PolicyLayout from "./PolicyLayout";

function PackagingPolicy() {
  return (
    <PolicyLayout
      title="Packaging and sustainability policy"
      intro="Packaging decisions for this catalogue begin with preventing breakage, leakage, food contamination and avoidable product loss."
    >
      <section>
        <h2>Protection by product type</h2>
        <p>Ceramics, mirrors, glass and bottles are immobilised and separated so hard surfaces do not strike each other. Food and beverages stay in their sealed primary packs. Sharp pins and small fittings are secured. Cotton, embroidery, paper shades and electrical parts are isolated from moisture and loose liquids.</p>
      </section>

      <section>
        <h2>Right-sizing and mixed orders</h2>
        <p>Outer packaging should fit the item and required cushioning without compressing fragile or food packaging. Compatible order lines may be consolidated. Incompatible shapes, liquids or safety risks may be separated when one parcel would increase damage or contamination risk.</p>
      </section>

      <section>
        <h2>Reuse and disposal</h2>
        <p>Keep protective material until the order has been inspected. Afterwards, clean undamaged packing may be reused where that is hygienic and safe. Separate paper, card, film, metal and glass according to the collection rules where the recipient lives. Food-contaminated, broken or sharp material should be wrapped and disposed of through the appropriate local waste route.</p>
      </section>

      <section>
        <h2>Environmental representation</h2>
        <p>Packaging colour, texture or recyclability symbol should be read only with its actual material instructions and local collection rules. Product protection is not described as carbon neutrality, recycled-content certification or another environmental performance standard unless a specific substantiated statement accompanies the product.</p>
      </section>

      <section>
        <h2>Packaging problem reports</h2>
        <p>For excessive movement, leakage, missing protection or unsafe sharp exposure, photograph the unopened parcel and each packaging layer before disposal where safe. The report is used to assess both the product remedy and future packing risk.</p>
      </section>
    </PolicyLayout>
  );
}

export default PackagingPolicy;
